import { useNavigate } from 'react-router-dom';
import { AlertCircle, Home } from 'lucide-react';
import { Button } from '../components/ui/button';

export function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="text-center">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-[#E91E8C]/10 mb-6">
          <AlertCircle className="w-10 h-10 text-[#E91E8C]" />
        </div>
        
        <h1 className="text-4xl mb-3 text-[#2d2d2d]">404</h1>
        <h2 className="text-xl mb-2 text-[#2d2d2d]">Página no encontrada</h2>
        <p className="text-gray-600 mb-8 max-w-md">
          Lo sentimos, la página que buscas no existe o ha sido movida.
        </p>
        
        <Button
          onClick={() => navigate('/dashboard')}
          className="bg-[#E91E8C] hover:bg-[#d01a7d] text-white"
        >
          <Home className="w-5 h-5 mr-2" />
          Volver al Inicio
        </Button>
      </div>
    </div>
  );
}
